import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectMilestoneSessionProjectMilestoneAuditHistoryRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectMilestoneSessionProjectMilestoneAuditHistory";
        this.parentEnterpriseComponent = "ProjectMilestoneSession";
        this.childEnterpriseComponent = "ProjectMilestoneAuditHistory";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "SessionUSID";
    }
}

export default ProjectMilestoneSessionProjectMilestoneAuditHistoryRelationshipMetadata;